import { getSettingsItemValue } from '@/components/settings-page';
import CustomizationsDataContext from '@/contexts/customizations-data-context';
import { applyThemeToDOM } from '@/styles/theme';
import axios, { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { DefaultTheme } from 'styled-components/dist/types';

export interface ICustomizationsData {
  theme: DefaultTheme;
  menuConfig: { [key: string]: any };
  logos: { [key: string]: string };
}

export const CustomizationsDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<ICustomizationsData | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/system/customizations`);
        const theme = getSettingsItemValue(response?.data ?? [], 'theme') || {};
        const menuConfig = getSettingsItemValue(response?.data ?? [], 'menuConfig') || {};
        const logos = getSettingsItemValue(response?.data ?? [], 'logos') || {};
        setData({ theme, menuConfig, logos });

        // Apply theme as CSS custom properties to document root
        applyThemeToDOM(theme);
      } catch (err) {
        const error = err as AxiosError;
        console.error(error);
      }
    })();
  }, []);

  const updateCustomizationsDataByKey = (key: keyof ICustomizationsData, value: any) => {
    setData((prevData) => {
      if (!prevData) return prevData;
      const newData = { ...prevData, [key]: value };

      // Update CSS custom properties when theme changes
      if (key === 'theme') {
        applyThemeToDOM(value);
      }

      return newData;
    });
  };

  if (!data) return null;

  return (
    <CustomizationsDataContext.Provider value={{ data, updateCustomizationsDataByKey }}>
      <ThemeProvider theme={data.theme}>{children}</ThemeProvider>
    </CustomizationsDataContext.Provider>
  );
};
